<template>
    <div class="d-flex" v-if="params.data.transaction_id">
        <responsive-button
            :icon="['fas', 'id-card']"
            variant="default"
            @click="requestImage"
            title="Download ID Photo"
            class="mr-2"
        ></responsive-button>
        <responsive-button
            v-if="params.data.verified_on"
            :icon="['fas', 'image-portrait']"
            variant="default"
            @click="requestSelfieImage"
            title="Download Selfie Photo"
            class="mr-2"
        ></responsive-button>
    </div>
    <div v-else>No Photos</div>
</template>

<script>
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
export default {
    components: {
        ResponsiveButton,
    },
    methods: {
        async requestImage() {
            this.params.requestImage && this.params.requestImage(this.params.data.id);
        },
        async requestSelfieImage() {
            this.params.requestSelfieImage && this.params.requestSelfieImage(this.params.data.id);
        },
    },
};
</script>

<style>
</style>